<template>
  <v-app>
    <Loading v-if="$store.state.loading" />
    <router-view></router-view>
  </v-app>
</template>

<script>
import Loading from '@/components/Loading'
import axios from 'axios'

export default {
  name: 'App',
  components: { Loading },

  created() {
    const redirects = {
      'https://nybussibalsta.resvana.se/': '/t/ul',
      'https://dagab.resvana.se/': '/t/dagab',
      'https://dahl.resvana.se/': '/t/dahl'
    }

    const currentUrl = window.location.href
    if (redirects[currentUrl]) {
      window.location.replace(this.$apiUrl + redirects[currentUrl])
      return
    }

    // Register activity every 15 seconds
    let intervalCount = 1

    setInterval(() => {
      if (document.hidden || intervalCount > 500) {
        return
      }

      if (
        !this.$router.currentRoute.name.includes('Survey') &&
        this.$store.state.endUser.slug
      ) {
        axios.post(this.$apiUrl + '/api/heartbeat', {
          slug: this.$store.state.endUser.slug,
          seconds: intervalCount * 15
        })
        intervalCount++
      }

      if (
        this.$router.currentRoute.name.includes('Survey') &&
        this.$router.currentRoute.params.slug &&
        !this.$store.state.surveySent
      ) {
        axios.post(this.$apiUrl + '/api/survey/mobility/heartbeat', {
          slug: this.$router.currentRoute.params.slug,
          seconds: intervalCount * 15,
          surveyId: this.$store.state.surveyId
        })
        intervalCount++
      }
    }, 15 * 1000)
  }
}
</script>
